import { getElementExists } from "../helper/helper";

export function cf7MailSentHandler(
  identifier,
  { title = "Nachricht erhalten", message = "Vielen Dank für Ihre Nachricht. Wir melden uns bei Ihnen." } = {}
) {
  document.addEventListener("wpcf7mailsent", (evt) => {
    const contactFormSevenForm = document
      .querySelector(identifier)
      .closest("form");

    if (!getElementExists(contactFormSevenForm)) {
      console.log("Form not found.", "identifier:", identifier);
      return;
    }

    if (evt.target === contactFormSevenForm) {
      evt.preventDefault();
      fillFormValues(evt, identifier);
      showPopup(evt, identifier, title, message);
    }
  });
}

function fillFormValues(evt, identifier) {
  const inputData = evt.detail.inputs;
  const formData = Array.from(
    document.querySelector(identifier).closest("form").elements
  );

  inputData.forEach((currentInput) => {
    const currentFormField = formData.filter((formField) => {
      return (
        formField.hasAttribute("name") &&
        formField.getAttribute("name") === currentInput.name
      );
    })[0];

    if (currentFormField === null) return;

    currentFormField.setAttribute("value", currentInput.value);

    if (
      currentFormField.hasAttribute("aria-invalid") &&
      currentFormField.getAttribute("aria-invalid") == true
    ) {
      currentFormField.setAttribute("aria-invalid", "false");
    }
  });

  document
    .querySelector(identifier)
    .closest("form")
    .querySelector(".wpcf7-response-output").style.display = "none";

  return;
}

function showPopup(evt, identifier, title, message) {
  if (message === null || message === "") {
    message = evt.detail.apiResponse.message;
  }

  const messageDialog = document.createElement("dialog");
  messageDialog.classList.add("client-registration-mail-feedback");

  const closeBtn = document.createElement("div");
  closeBtn.setAttribute("role", "button");
  closeBtn.classList.add("close");
  closeBtn.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.533 15.424"><path d="M7.767,9.478,1.82,15.424,0,13.608,5.895,7.714,0,1.819,1.82,0,7.767,5.949,13.713,0l1.82,1.819L9.639,7.714l5.895,5.895-1.82,1.816Z" fill="currentColor"/></svg>';

  closeBtn.addEventListener("pointerdown", (evt) => {
    evt.target.closest("dialog").close();
  });

  messageDialog.appendChild(closeBtn);

  const headline = document.createElement("div");
  headline.classList.add("h3");
  headline.innerHTML = title;

  messageDialog.appendChild(headline);

  const description = document.createElement("div");
  description.classList.add("description");
  description.innerHTML = message;

  messageDialog.appendChild(description);

  document.body.appendChild(messageDialog);

  // Save current scroll position and fix body
  const scrollY = window.scrollY;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.width = '100%';
  
  messageDialog.showModal();
  
  // Restore body position when dialog closes
  messageDialog.addEventListener('close', () => {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
    messageDialog.remove();
  });
}
